// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__y4hbk","label":"Section_label__rYXJ9","contentWrap":"Section_contentWrap__22-fT","footer":"Section_footer__1_fGH","footerInner":"Section_footerInner__1Hv7W"};